/**
 * The Sent / Delivered / Seen state for my latest DM message — three honest
 * states from what we actually know. Pure (extracted from `ChatThread.tsx`)
 * so it unit-tests directly:
 *   - **Seen** — the recipient's read cursor has passed this message;
 *   - **Delivered** — not yet read, but the recipient is online (their live
 *     socket has the message), so it best-effort reached them;
 *   - **Sent** — not read and the recipient is offline (they'll pick it up
 *     from history).
 */
export type DeliveryState = "Seen" | "Delivered" | "Sent";

export function deliveryStatusLabel(read: boolean, recipientOnline: boolean): DeliveryState {
  return read ? "Seen" : recipientOnline ? "Delivered" : "Sent";
}
